import { BodyText, getTextStyles } from '@postscript/components';
import styled from 'styled-components';

const StyledDynamicImagePreview = styled.div`
  background-color: var(--flow-builder-dynamic-image-bkg);
  display: grid;
  grid-template-areas:
    'icon title'
    'icon description';
  grid-template-columns: var(--spacing-8) 1fr;
  grid-template-rows: auto 1fr;
  padding: calc(var(--spacing-1) / 2) var(--spacing-2)
    calc(var(--spacing-1) / 2) calc(var(--spacing-1) / 2);
  width: 100%;
`;

const StyledIconArea = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: var(--spacing-9);
`;

const StyledInfoArea = styled.div`
  padding: calc(var(--spacing-1) / 2) var(--spacing-3)
    calc(var(--spacing-1) / 2) 0;
`;

const StyledBodyTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledBodyText = styled(BodyText)`
  color: var(--flow-builder-dynamic-image-text);
`;

const StyledCardLink = styled.a`
  color: var(--flow-builder-dynamic-image-text);
  text-decoration: none;
  margin-left: var(--spacing-2);
  ${getTextStyles.bodyText('small', { isBold: true })};

  &:hover,
  &:active {
    color: var(--flow-builder-dynamic-image-text);
    text-decoration: underline;
  }
`;

interface NonrepresentationalMediaPreviewProps {
  description: string;
  title: string;
  icon: JSX.Element;
  link?: string;
  linkText?: string;
}

const NonrepresentationalMediaPreview = ({
  description,
  title,
  icon,
  link,
  linkText,
}: NonrepresentationalMediaPreviewProps): JSX.Element => (
  <StyledDynamicImagePreview>
    <StyledIconArea>{icon}</StyledIconArea>
    <StyledInfoArea>
      <BodyText
        bold
        size="small"
        color="var(--flow-builder-dynamic-image-text)}"
      >
        {title}
      </BodyText>
      <StyledBodyTextWrapper>
        <StyledBodyText size="x-small">{description}</StyledBodyText>
        {link && (
          <StyledCardLink href={link} target="_blank" rel="noreferrer">
            {linkText}
          </StyledCardLink>
        )}
      </StyledBodyTextWrapper>
    </StyledInfoArea>
  </StyledDynamicImagePreview>
);

export default NonrepresentationalMediaPreview;
